import { BACKEND_BASE_URL } from "../config/app.config";
import { httpPost } from "./http.service";

const TERMINATE_USER_SESSION = `${BACKEND_BASE_URL}/api/terminate-user-session`;

const terminateUserSession = async (username: string) => {
  try {
    const response = await httpPost(`${TERMINATE_USER_SESSION}`, {
      username,
    });
    if (response?.data?.status === "success") {
      return true;
    } else {
      return false;
    }
  } catch (error: any) {
    throw error?.data?.error;
  }
};

export { terminateUserSession };
